import { render, staticRenderFns } from "./ReservationAddButton.vue?vue&type=template&id=2abe6135"
import script from "./ReservationAddButton.vue?vue&type=script&lang=js"
export * from "./ReservationAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports